module.exports = __webpack_public_path__ + "static/media/Fwsx2giaMAA_pEn.1dae129f.webp";